import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ChannelModel } from "../../../shared/models/channel";
import { RegionModel } from "../../../shared/models/region";
import { StateModel } from "../../../shared/models/state";
import {
  PosmAudityTypesModel,
  VisibilityModel,
} from "../../../shared/models/visibility";
import { ChannelProvider } from "../../../shared/providers/channel.provider";
import { AdminDataProvider } from "../../../shared/providers/master-provider/admin-data.provider";
import { RegionProvider } from "../../../shared/providers/region.provider";
import { StateProvider } from "../../../shared/providers/state.provider";
import { VisibilityProvider } from "../../../shared/providers/visibility.provider";

@Component({
  selector: "app-visiblity-audit-types",
  templateUrl: "./visiblity-audit-types.component.html",
  styleUrls: ["./visiblity-audit-types.component.scss"],
})
export class VisiblityAuditTypesComponent implements OnInit {
  channels: ChannelModel[];
  filteredDetails: any = {
    search_string: "",
    regions: [],
    states: [],
    channels: [],
    posm_types: [],
    posm_elements: [],
  };

  filteredDetailsAPI: any = {
    search_string: "",
    regions: [],
    states: [],
    channels: [],
    posm_types: [],
    posm_elements: [],
  };
  getPaginationCount: number;
  pageNumber: number = 1;
  posmAuditTypes: PosmAudityTypesModel[];
  states: StateModel[];
  regions: RegionModel[];
  StatesfilterByRegion: StateModel[];
  posmElements: VisibilityModel[];
  posmElementsFilterByType: VisibilityModel[];
  posmType: any[];
  constructor(
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public activatedRoute: ActivatedRoute,
    public adminDataProvider: AdminDataProvider,
    public channelProvider: ChannelProvider,
    public stateProvider: StateProvider,
    public regionProvider: RegionProvider,
    public visiblityProvider: VisibilityProvider,
    private router: Router,
    public alertService: AlertService
  ) {
    this.posmType = [
      { id: 1, name: "Branding" },
      { id: 2, name: "Cooler" },
    ];
  }

  ngOnInit() {
    this.getPosmAuditTypes();
  }

  getPosmAuditTypes() {
    this.apiService
      .getHeaders(
        this.apiConfig.getPosmAuditTypes +
        "?page=" +
        this.pageNumber +
        "&posm_element_config_id=" +
        this.filteredDetailsAPI.posm_elements +
        "&channel_id=" +
        this.filteredDetailsAPI.channels +
        "&state_code=" +
        this.filteredDetailsAPI.states +
        "&region_id=" +
        this.filteredDetailsAPI.regions +
        "&posm_type=" +
        1 +
        "&search_string=" +
        this.filteredDetailsAPI.search_string
      )
      .subscribe(
        (res: any) => {
          this.posmAuditTypes = res.body.data as PosmAudityTypesModel[];
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          if (this.posmAuditTypes.length > 0) {
            this.posmAuditTypes.forEach((item) => {
              if (item.status == 1) {
                item.statusString = "Active";
              } else {
                item.statusString = "Inactive";
              }
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngDoCheck() {
    this.channels = this.channelProvider.channels;
    this.states = this.stateProvider.state;
    this.regions = this.regionProvider.regions;
    this.posmElements = this.visiblityProvider.visibility;
    if (typeof this.posmElements != "undefined") {
      if (this.posmElements.length > 0) {
        this.posmElements = this.posmElements.filter(i => i.element_type == 1)
      }
    }
  }

  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails.regions = await data;
        this.StatesfilterByRegion = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion.push(
            ...this.states.filter(
              (s) => s.region_id == element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 2: // State
        this.filteredDetails.states = await data;
        break;
      case 3: // geography
        this.filteredDetails.channels = await data;
        break;
      case 4: // geography
        this.filteredDetails.posm_types = await data;
        break;
      case 5:
        this.filteredDetails.posm_elements = await data;
      default:
        break;
    }
  }

  paginationClick(item) {
    this.pageNumber = item;
    this.getPosmAuditTypes();
  }

  filterListOfRecords() {
    try {
      this.filteredDetailsAPI.states = this.filteredDetails.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.posm_types = this.filteredDetails.posm_types
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.posm_elements = this.filteredDetails.posm_elements
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.channels = this.filteredDetails.channels
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsAPI.search_string = this.filteredDetails.search_string;
      this.getPosmAuditTypes();
    } catch (error) { }
  }

  changeStatus(item: PosmAudityTypesModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updatePosmAuditTypes + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
        this.getPosmAuditTypes();
      });
  }

  editTemplate(item: PosmAudityTypesModel) {
    this.router.navigate(["/", "hubAdmin", "visibility-template", item.id]);
  }

  redirectToAddAndEdit() {
    this.router.navigate(["/", "hubAdmin", "visibility-template", ""]);
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }
}
